module.exports = "img/button-text-inline-code.1dd627f.svg";